import { useContext as e } from "react";
import r from "../context/ScreenReaderContext/ScreenReaderContext.js";
import "react/jsx-runtime";
import "nanoid";
import "../components/VisuallyHidden/VisuallyHidden.js";
function p() {
  return e(r);
}
export {
  p as default
};
